import { candidateJobsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

//apply job
export const apply_job_candidate_action = (data, id) => async (dispatch) => {
  
  const user = JSON.parse(localStorage.getItem("jigsawUser"));

  dispatch({
    type: candidateJobsConstants.CANDIDATE_APPLY_JOB_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.candidate.applyJob.replace(":id", id),
      data
    );
    if (response.status) {
      dispatch({
        type: candidateJobsConstants.CANDIDATE_APPLY_JOB_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage("Successfully applied.");
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateJobsConstants.CANDIDATE_APPLY_JOB_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//applied job detail
export const get_applied_job_details_candidate_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOB_DETAILS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.appliedJobDetails.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOB_DETAILS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOB_DETAILS_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//all applied jobs
export const get_applied_jobs_list_candidate_action =
  (page) => async (dispatch) => {
    dispatch({
      type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOBS_LIST_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.appliedJobs}?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOBS_LIST_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOBS_LIST_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//all applied jobs
export const get_applied_jobs_summary_candidate_action =
  (page) => async (dispatch) => {
    dispatch({
      type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOBS_SUMMARY_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.getAppliedJobsSummary}`
      );
      if (response.status) {
        dispatch({
          type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOBS_SUMMARY_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateJobsConstants.GET_CANDIDATE_APPLIED_JOBS_SUMMARY_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//all applied jobs
export const get_candidate_job_offer_details_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateJobsConstants.GET_CANDIDATE_JOB_OFFER_DETAILS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.updateCandidateJobOffer.replace(":id", id)}`
      );
      if (response.status) {
        dispatch({
          type: candidateJobsConstants.GET_CANDIDATE_JOB_OFFER_DETAILS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateJobsConstants.GET_CANDIDATE_JOB_OFFER_DETAILS_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//all applied jobs
export const update_candidate_job_offer_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: candidateJobsConstants.UPDATE_CANDIDATE_JOB_OFFER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        `${config.candidate.updateCandidateJobOffer.replace(":id", id)}`,
        data
      );
      let success_str =
        data && data.offer_accepted
          ? "Offer Accepted Successfully"
          : "Offer Rejected Successfully";
      if (response.status) {
        dispatch({
          type: candidateJobsConstants.UPDATE_CANDIDATE_JOB_OFFER_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage(success_str);
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateJobsConstants.UPDATE_CANDIDATE_JOB_OFFER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//Reject Invitaion jobs
export const reject_job_invitation_action = (id, data) => async (dispatch) => {
  dispatch({
    type: candidateJobsConstants.REJECT_JOB_INVITATION_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(
      `${config.common.rejectJobInvitaton.replace(":id", id)}`,
      data
    );
    let success_str = "Job Invitation  Rejected Successfully";

    if (response.status) {
      dispatch({
        type: candidateJobsConstants.REJECT_JOB_INVITATION_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage(success_str);
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateJobsConstants.REJECT_JOB_INVITATION_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};
